<template>
  <el-form-item
    class="widget-view"
    v-if="element && element.key"
    :class="{
      active: selectWidget.key === element.key,
      is_req: element.options.required,
    }"
    :label-width="
      element.options.labelWidth >= 0
        ? element.options.labelWidth + 'px'
        : isShowLabel
          ? ''
          : '1'
    "
    @click.native.stop="handleSelectWidget(index)"
  >
    <span slot="label" v-if="element.showName && isShowLabel">
      <span v-if="element.options.customDesc" class="sw-form-desc"
        ><i class="el-icon-question"></i></span
      >{{ element.name }}
    </span>
    <template v-if="element.type === 'input'">
      <!-- 是否为车牌组件 -->
      <template v-if="element.options.hasOwnProperty('carNumberOptions')">
        <car-number-widget :options="element.options.carNumberOptions" />
      </template>
      <!-- 普通input -->
      <template v-else>
        <el-input
          v-model="element.options.defaultValue"
          :style="{ width: element.options.width }"
          :disabled="element.options.disabled || dataConfig.disabled"
          :placeholder="element.options.placeholder"
        >
          <template
            slot="append"
            v-if="
              element.suffix && element.suffix !== null && element.suffix !== ''
            "
            >{{ element.suffix }}</template
          >
        </el-input>
      </template>
    </template>

    <template v-if="element.type === 'textarea'">
      <el-input
        type="textarea"
        :rows="5"
        v-model="element.options.defaultValue"
        :style="{ width: element.options.width }"
        :disabled="element.options.disabled || dataConfig.disabled"
        :placeholder="element.options.placeholder"
      ></el-input>
    </template>

    <template v-if="element.type === 'number'">
      <el-input-number
        v-model="element.options.defaultValue"
        :disabled="element.options.disabled || dataConfig.disabled"
        :controls-position="element.options.controlsPosition"
        :style="{ width: element.options.width }"
      ></el-input-number>
    </template>

    <template v-if="element.type === 'radio'">
      <el-radio-group
        v-model="element.options.defaultValue"
        :style="{ width: element.options.width }"
        :disabled="element.options.disabled || dataConfig.disabled"
      >
        <el-radio
          :style="{
            display: element.options.inline ? 'inline-block' : 'block',
          }"
          :label="item.value"
          v-for="(item, index) in element.options.options"
          :key="index"
        >
          {{ element.options.showLabel ? item.label : item.value }}
        </el-radio>
      </el-radio-group>
    </template>

    <template v-if="element.type === 'checkbox'">
      <el-checkbox-group
        v-model="element.options.defaultValue"
        :style="{ width: element.options.width }"
        :disabled="element.options.disabled || dataConfig.disabled"
      >
        <el-checkbox
          :style="{
            display: element.options.inline ? 'inline-block' : 'block',
          }"
          :label="item.value"
          v-for="(item, index) in element.options.options"
          :key="item.value + index"
        >
          {{ element.options.showLabel ? item.label : item.value }}
        </el-checkbox>
      </el-checkbox-group>
    </template>

    <template v-if="element.type === 'time'">
      <el-time-picker
        v-model="element.options.defaultValue"
        :is-range="element.options.isRange"
        :placeholder="element.options.placeholder"
        :start-placeholder="element.options.startPlaceholder"
        :end-placeholder="element.options.endPlaceholder"
        :readonly="element.options.readonly"
        :disabled="element.options.disabled || dataConfig.disabled"
        :editable="element.options.editable"
        :clearable="element.options.clearable"
        :arrowControl="element.options.arrowControl"
        :style="{ width: element.options.width }"
      >
      </el-time-picker>
    </template>

    <template v-if="element.type === 'date'">
      <el-date-picker
        v-model="element.options.defaultValue"
        :type="element.options.type"
        :is-range="element.options.isRange"
        :placeholder="element.options.placeholder"
        :start-placeholder="element.options.startPlaceholder"
        :end-placeholder="element.options.endPlaceholder"
        :readonly="element.options.readonly"
        :disabled="element.options.disabled || dataConfig.disabled"
        :editable="element.options.editable"
        :clearable="element.options.clearable"
        :style="{ width: element.options.width }"
      >
      </el-date-picker>
    </template>

    <template v-if="element.type === 'rate'">
      <el-rate
        v-model="element.options.defaultValue"
        :max="element.options.max"
        :disabled="element.options.disabled || dataConfig.disabled"
        :allow-half="element.options.allowHalf"
      ></el-rate>
    </template>

    <template v-if="element.type === 'color'">
      <el-color-picker
        v-model="element.options.defaultValue"
        :disabled="element.options.disabled || dataConfig.disabled"
        :show-alpha="element.options.showAlpha"
      ></el-color-picker>
    </template>

    <template v-if="element.type === 'select'">
      <el-select
        v-model="element.options.defaultValue"
        :disabled="element.options.disabled || dataConfig.disabled"
        :multiple="element.options.multiple"
        :clearable="element.options.clearable"
        :placeholder="element.options.placeholder"
        :style="{ width: element.options.width }"
      >
        <el-option
          v-for="(item, index) in element.options.options"
          :key="index"
          :value="item.value"
          :label="element.options.showLabel ? item.label : item.value"
        ></el-option>
      </el-select>
    </template>

    <template v-if="element.type === 'switch'">
      <el-switch
        v-model="element.options.defaultValue"
        :disabled="element.options.disabled || dataConfig.disabled"
      >
      </el-switch>
    </template>

    <template v-if="element.type === 'slider'">
      <el-slider
        v-model="element.options.defaultValue"
        :min="element.options.min"
        :max="element.options.max"
        :disabled="element.options.disabled || dataConfig.disabled"
        :step="element.options.step"
        :show-input="element.options.showInput"
        :range="element.options.range"
        :style="{ width: element.options.width }"
      ></el-slider>
    </template>

    <template v-if="element.type === 'imgupload'">
      <fm-upload
        v-model="element.options.defaultValue"
        :disabled="element.options.disabled || dataConfig.disabled"
        :style="{ width: element.options.width }"
        :width="element.options.size.width"
        :app-id="element.options.appId"
        :height="element.options.size.height"
        :action="element.options.action"
        :show-img="false"
      >
      </fm-upload>
    </template>

    <template v-if="element.type === 'cascader'">
      <el-cascader
        v-model="element.options.defaultValue"
        :disabled="element.options.disabled || dataConfig.disabled"
        :clearable="element.options.clearable"
        :placeholder="element.options.placeholder"
        :style="{ width: element.options.width }"
        :options="element.options.remoteOptions"
      >
      </el-cascader>
    </template>

    <template v-if="element.type === 'editor'">
      <fm-editor
        v-model="element.options.defaultValue"
        :width="element.options.width"
        :disabled="element.options.disabled || dataConfig.disabled"
        :height="element.options.height"
      >
      </fm-editor>
    </template>

    <template v-if="element.type === 'file'">
      <el-upload
        class="upload-demo"
        :disabled="element.options.disabled || dataConfig.disabled"
        :drag="element.options.showType === 'drag'"
        action=""
      >
        <el-button
          v-if="element.options.showType === 'btn'"
          slot="trigger"
          size="small"
          type="primary"
          >选取文件</el-button
        >
        <i
          v-if="element.options.showType === 'drag'"
          class="el-icon-upload"
        ></i>
        <div class="el-upload__text" v-if="element.options.showType === 'drag'">
          将文件拖到此处，或<em>点击上传</em>
        </div>
        <div class="el-upload__text" v-if="element.options.showType === 'btn'">
          点击按钮,选取上传文件
        </div>
      </el-upload>
    </template>

    <template v-if="element.type === 'address'">
      <el-cascader
        v-model="element.options.defaultValue.selectValue"
        :disabled="element.options.disabled || dataConfig.disabled"
        :clearable="element.options.clearable"
        :placeholder="element.options.placeholder"
        :style="{ width: element.options.width }"
        :options="element.options.remoteOptions"
      >
      </el-cascader
      ><br />
      <el-input
        v-if="element.options.isShowDetailInput"
        v-model="element.options.defaultValue.inputValue"
        style="margin-top: 5px"
        :style="{ width: element.options.width }"
        :placeholder="element.options.placeholder2"
      ></el-input>
    </template>

    <template v-if="element.type === 'organization'">
      <el-cascader
        v-model="element.options.defaultValue"
        :disabled="element.options.disabled || dataConfig.disabled"
        :clearable="element.options.clearable"
        :placeholder="element.options.placeholder"
        :style="{ width: element.options.width }"
        :options="element.options.remoteOptions"
      >
      </el-cascader>
    </template>

    <template v-if="element.type === 'user'">
      <el-cascader
        v-model="element.options.defaultValue"
        :disabled="element.options.disabled || dataConfig.disabled"
        :clearable="element.options.clearable"
        :placeholder="element.options.placeholder"
        :style="{ width: element.options.width }"
        :options="element.options.remoteOptions"
      >
      </el-cascader>
    </template>

    <template v-if="element.type === 'swtext'">
      <div
        v-if="!element.options.isTextEditor"
        v-html="element.options.defaultValue"
      ></div>
      <div
        v-if="element.options.isTextEditor"
        class="sw-edit-text ql-editor"
        v-html="element.options.defaultValue"
      ></div>
    </template>

    <template v-if="element.type === 'table'">
      <sw-table :widget="element"> </sw-table>
    </template>
    <template v-if="element.type === 'esign'">
      <Esign :widget="element" />
    </template>
    <template v-if="element.type === 'page'">
      <sw-page
        :element="element"
        :index="index"
        :data="data"
        :data-config="data.config"
      ></sw-page>
    </template>
    <template v-if="element.type === 'location'">
      <location></location>
    </template>

    <div class="widget-view-action" v-if="selectWidget.key === element.key">
      <i
        class="el-icon-document-copy"
        v-if="element.type !== 'page'"
        @click.stop="handleWidgetClone(index)"
      ></i>
      <i class="el-icon-delete" @click.stop="handleWidgetDelete(index)"></i>
    </div>

    <div class="widget-view-drag" v-if="selectWidget.key === element.key">
      <i class="su-icon-tuodong drag-widget"></i>
    </div>
  </el-form-item>
</template>

<script>
import FmUpload from './Upload'
import FmEditor from './UEditor/index'
import SwPage from './advanced/page'
import SwTable from './advanced/table'
import Location from './advanced/location/widget'
import Esign from './Esign/widgetIndex'
import carNumberWidget from './advanced/carNumber/widget'
export default {
  name: 'widget-form-item',
  props: ['element', 'select', 'index', 'data', 'dataConfig', 'fromSonForm'],
  components: {
    FmUpload,
    FmEditor,
    SwPage,
    SwTable,
    Esign,
    Location,
    carNumberWidget,
  },
  data() {
    return {
      isShowLabel: true,
      selectWidget: this.select,
    }
  },
  created() {
    if (this.fromSonForm) {
      this.isShowLabel = false
    }
  },
  methods: {
    handleSelectWidget(index) {
      this.selectWidget = this.data.list[index]
    },
    handleWidgetDelete(index) {
      if (this.data.list.length === 1) {
        this.$emit('select-change', -1)
      } else {
        if (this.data.list.length - 1 === index) {
          this.$emit('select-change', index - 1)
        } else {
          this.$emit('select-change', index)
        }
      }
      this.$nextTick(() => {
        this.data.list.splice(index, 1)
      })
    },
    handleWidgetClone(index) {
      const cloneData = JSON.parse(JSON.stringify(this.data.list[index]))
      const key = new Date().getTime() + ''
      cloneData.key = key
      cloneData.model = this.data.list[index].type + '_' + key
      this.data.list.splice(index, 0, cloneData)
      this.$nextTick(() => {
        this.selectWidget = this.data.list[index + 1]
      })
    },
  },
  watch: {
    select(val) {
      this.selectWidget = val
    },
    selectWidget: {
      handler(val, oldVal) {
        if (JSON.stringify(val) !== JSON.stringify(oldVal)) {
          this.$emit('update:select', val)
        }
      },
      deep: true,
    },
  },
}
</script>
<style lang="scss" scoped>
.sw-edit-text {
  min-height: auto;
  margin: 0;
  padding: 0;
  line-height: 32px;
}
</style>
